const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Project Assignment Report",
            href: "#",
            arrow: "",
        },
    ],

    breadcrumb_project_completion_room: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Project Completion by Room",
            href: "/standard-reports/projects/project-completion-room",
            arrow: "",
        },
    ],

    rooms_report_table_headers: [
        {
            text: 'Description',
            align: 'start',
            value: 'custom_description',
            report_value: 'custom_description',
            show: true,
        },
        {
            text: 'Frequency',
            value: 'frequency_name',
            report_value: 'frequency_name',
            sort_type: 'text',
            show: true,
        },
        {
            text: 'Room Type',
            value: 'room_type_description',
            report_value: 'room_type_description',
            show: true,
        },
        {
            text: 'Task',
            value: 'task',
            report_value: 'task',
            show: true,
        },
        {
            text: 'Last Completed',
            value: 'last_completed',
            report_value: 'last_completed',
            show: true,
        },
        {
            text: 'Next Scheduled',
            value: 'next_scheduled',
            report_value: 'next_scheduled',
            show: true,
        },
        {
            text: 'Minutes',
            value: 'daily_minutes',
            report_value: 'daily_minutes',
            show: true,
        },
    ],

    rooms_report_table_headers_employee: [
        {
            text: 'Description',
            align: 'start',
            value: 'custom_description',
            report_value: 'custom_description',
            show: true,
        },
        {
            text: 'Room Type',
            value: 'room_type_description',
            report_value: 'room_type_description',
            show: true,
        },
        {
            text: 'Task',
            value: 'task',
            report_value: 'task',
            show: true,
        },
        {
            text: 'Complete',
            value: 'checkbox',
            type: 'checkbox',
            report_value: 'checkbox',
            show: true,
        },
    ],

    rooms_report_totals: [
        {
            daily_minutes:
            {
                show: true,
                text: 'Minutes',
                value: 0,
            },
            
        },
    ],

    project_completion_room_table_headers: [
        {
            text: 'Scheduled Date',
            align: 'start',
            value: 'last_completed',
            report_value: 'last_completed',
            show: true,
            style: "width: 10%;"
        },
        {
            text: 'Room',
            value: 'custom_description',
            report_value: 'custom_description',
            sort_type: 'text',
            show: true,
            style: "width: 20%;"
        },
        {
            text: 'Project Code',
            value: 'task',
            report_value: 'task',
            show: true,
            style: "width: 10%;"
        },
        {
            text: 'Sq. ft',
            value: 'sq_ft',
            report_value: 'sq_ft',
            show: true,
            style: "width: 5%;"
        },
        {
            text: 'Scheduled Minutes',
            value: 'daily_minutes',
            report_value: 'daily_minutes',
            show: true,
            style: "width: 8%;"
        },
        {
            text: 'Completed Minutes',
            value: 'actual_minutes',
            report_value: 'actual_minutes',
            show: true,
            style: "width: 8%;"
        },
    ],

    project_completion_room_report_totals: [
        {
            daily_minutes:
            {
                show: true,
                text: 'Minutes',
                value: 0,
            },
            actual_minutes:
            {
                show: true,
                text: 'Minutes',
                value: 0,
            },
            sq_ft:
            {
                show: true,
                text: 'Sq. ft',
                value: 0,
            },
        },
    ],

    next_scheduled_projects_table_headers: [
        {
            text: 'Next Scheduled Date',
            align: 'start',
            value: 'next_scheduled',
            report_value: 'next_scheduled',
            show: true,
            style: "width: 10%;"
        },
        {
            text: 'Room',
            value: 'custom_description',
            report_value: 'custom_description',
            sort_type: 'text',
            show: true,
            style: "width: 20%;"
        },
        {
            text: 'Project Code',
            value: 'task',
            report_value: 'task',
            show: true,
            style: "width: 10%;"
        },
        {
            text: 'Frequency',
            value: 'frequency_name',
            report_value: 'frequency_name',
            show: true,
            style: "width: 10%;"
        },
    ],

}

export default Resources;